DataLinkApi = LP.module 'DataLinkApi'
DataLinkApi.site = ->
  $('[data-link]').on 'click', (event) ->
    link = $(this).data('link')
    if (typeof link is 'string') and (link.length > 0)
      event.stopPropagation()
      window.location.href = link
